// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui.form .field {
  margin-top: 5px;
}

.text-area {
  margin: 5px auto 20px !important;
  height: 150px;
}`, "",{"version":3,"sources":["webpack://./src/Components/FeedbackModal/FeedbackModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,gCAAA;EACA,aAAA;AACF","sourcesContent":[".ui.form .field {\n  margin-top: 5px;\n}\n\n.text-area {\n  margin: 5px auto 20px !important;\n  height: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
